import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CalendarDays, Printer } from "lucide-react";

interface QualityPrintControlsProps {
  reportDate: string;
  onReportDateChange: (value: string) => void;
  showDate?: boolean;
  showButton?: boolean;
}

export default function QualityPrintControls({
  reportDate,
  onReportDateChange,
  showDate = true,
  showButton = true,
}: QualityPrintControlsProps) {
  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <style>{`
        @media print {
          @page {
            size: landscape;
            margin: 0.35in;
          }

          body {
            background: #fff !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          body * {
            visibility: hidden !important;
          }

          #quality-print-scope,
          #quality-print-scope * {
            visibility: visible !important;
          }

          #quality-print-scope {
            position: absolute !important;
            inset: 0 auto auto 0 !important;
            width: 100% !important;
            max-width: none !important;
            padding: 0 !important;
            margin: 0 !important;
            overflow: visible !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          .quality-print-hide {
            display: none !important;
          }

          .quality-print-header {
            display: flex !important;
          }

          .quality-print-card {
            break-inside: avoid;
          }

          .quality-print-table {
            overflow: visible !important;
          }

          .quality-print-table table {
            font-size: 10px !important;
          }

          .quality-print-table th,
          .quality-print-table td {
            padding: 5px 6px !important;
          }

          .quality-print-plain-input {
            border: 0 !important;
            box-shadow: none !important;
            background: transparent !important;
            color: #0f172a !important;
            padding: 0 !important;
            font: inherit !important;
            line-height: inherit !important;
            height: auto !important;
            min-height: 0 !important;
            -webkit-appearance: none !important;
            appearance: none !important;
            text-align: right !important;
          }

          .quality-print-plain-pill,
          .quality-print-plain-pill * {
            font-size: inherit !important;
            font-weight: inherit !important;
          }

          .quality-print-plain-pill {
            padding: 0 !important;
            min-width: 0 !important;
          }

          .quality-print-avoid-break {
            break-inside: avoid;
          }
        }
      `}</style>

      <div className="quality-print-hide flex items-center gap-2">
        {showDate && (
          <label className="inline-flex items-center gap-1.5 text-sm">
            <CalendarDays className="h-3.5 w-3.5 text-muted-foreground" />
            <span className="text-muted-foreground">Report Date:</span>
            <Input
              value={reportDate}
              onChange={(event) => onReportDateChange(event.target.value)}
              className="quality-print-plain-input h-6 w-24 border-0 bg-transparent p-0 text-sm font-medium text-foreground shadow-none focus-visible:ring-0"
              aria-label="Report date"
            />
          </label>
        )}
        {showButton && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handlePrint}
            className="h-8 px-2 text-muted-foreground hover:bg-transparent hover:text-foreground"
          >
            <Printer className="mr-2 h-4 w-4" />
            Print PDF
          </Button>
        )}
      </div>
    </>
  );
}
